import { createAsyncThunk } from '@reduxjs/toolkit';
import { TBaseRequest } from '~/store/types.ts';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';

export const processRepresentatives = createAsyncThunk<null, TBaseRequest>(
  'remoteBankingContacts/processRepresentatives',
  async ({ applicationId, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      };

      const response = await api.post(
        `/remote-banking-contacts/applications/${applicationId}/process-representatives`,
        null,
        { headers }
      );

      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
